import React, {Component, ReactElement, ReactNode} from 'react'
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCellForColgroup,
    ConditionTableBody,
    ConditionTableFixed,
    ConditionTableRow,
} from '../../../../styledComponents/adminPage/ConditionTable'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {
    ExcudeResidentUserInfo,
    NatGetRoomToResident,
    ResidentUserInfo,
    SearchResult,
} from '../../roomToResident/repository/NatGetRoomToResident'
import NatRoomToResidentRepo, {GetRoomToResidentParams} from '../../roomToResident/repository/NatRoomToResidentRepo'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {BackLink} from '../../../../styledComponents/adminPage/Links'
import {Messages} from '../../../../Messages'
import {SortOrder} from '../../../../components/shared/SortOrder'
import {Nullable} from '../../../../app/TypeHelpers'
import {formatDateTimeForUpdateDate} from '../../../../formatters/formatDate'
import {RESIDENT_STATUS, SELECT_USER_TYPE} from '../../../../CodeMaster'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import styled from 'styled-components'
import {AdminPageHeadingArea} from '../../../../components/shared/pageBaseComponents/AdminPageHeadingArea'
import NatRidgeRepo from '../../ridge/repository/NatRidgeRepo'
import PPSelect, {OptionProps} from '../../../../components/shared/forms/PPSelect'
import {AsyncCommunicationProps} from '../../../../components/shared/hoc/withAsyncCommunication'
import {NatGetRidge, RidgeData} from '../../ridge/repository/NatGetRidge'
import {HKConstants} from '../../../../HKConstants'
import ListSearchFormArea from '../../../../styledComponents/adminPage/ListSearchFormArea'
import {SelectedUserList} from '../../facilityReserve/repository/NatGetFacilityReserve'
import {getDisplayUserNameForManagement} from '../../../../components/reservations/admin/AdminReserveHelper'
import moment from 'moment'
import {SelectChangeEvent} from '@mui/material/Select'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    roomToResidentRepo: NatRoomToResidentRepo
    ridgeRepo: NatRidgeRepo
    selectUserType: string
    closeSelectResidentUserDiaLog: () => void
    setSelectedResidentUserInfo?: (selectedResidentUserInfo: ResidentUserInfo) => void
    setSelectedExclusionResidentUserInfo?: (selectedExclusionResidentUserInfo: SelectedUserList[]) => void
    selectedCondominiumCd?: string
    invalidUserSelectFlag: boolean
    eventEmitter: EventEmitterExAdmin
    navigate: NavigateFunction
    location: Location
    maxSelectableKeyNumber?: number
    selectedUserList?: SelectedUserList[]
    excudeResidentUserInfo?: Nullable<ExcudeResidentUserInfo>
    allResidentStatus?: boolean
    validPeriodCriteriaDate?: Nullable<moment.Moment>
    mainUserFlag?: boolean
    cardKeyNumberIsNotNullFlg?: boolean
    sameRoomDuplicateExclusionFlag?: boolean
    unregisteredResidentStatus?: boolean
}

interface States {
    searchCondition: GetRoomToResidentParams
    residentUsers: ResidentUserInfo[]
    searchConditionSortInfo: SortOrder[]
    searchResult: SearchResult
    clickSearchButton: boolean
    selectedUserList: SelectedUserList[]
    ridge: RidgeData[]
    selectedExcludeDisabled: boolean
}

export default class NatResidentUserSelectionComponent extends Component<Props & AsyncCommunicationProps, States> {


    constructor(props: Props & AsyncCommunicationProps) {
        super(props)

        this.state = {
            residentUsers: [],
            searchCondition: {
                validPeriodCriteriaDate: this.props.validPeriodCriteriaDate,
            },
            searchConditionSortInfo: [
                new SortOrder('ridgeCd', 'asc'),
                new SortOrder('roomNumber', 'asc'),
            ],
            searchResult: {
                ['total']: 0,
                ['limitOverFlag']: 0,
            },
            clickSearchButton: false,
            selectedUserList: (this.props.selectedUserList) ?
                JSON.parse(JSON.stringify(this.props.selectedUserList)) : [],
            ridge: [],
            selectedExcludeDisabled: false,
        }

        this.onChangeRidgeCd = this.onChangeRidgeCd.bind(this)
        this.onChangeRoomNumber = this.onChangeRoomNumber.bind(this)
        this.onChangeFamilyName = this.onChangeFamilyName.bind(this)
        this.onChangeFirstName = this.onChangeFirstName.bind(this)
        this.onChangeFamilyNameKana = this.onChangeFamilyNameKana.bind(this)
        this.onChangeFirstNameKana = this.onChangeFirstNameKana.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.updateSelectedResidentUserInfo = this.updateSelectedResidentUserInfo.bind(this)
        this.updateSelectedExclusionResidentUserInfo = this.updateSelectedExclusionResidentUserInfo.bind(this)
    }

    async componentDidMount(): Promise<void> {
        // 棟取得
        if (this.props.selectedCondominiumCd) {
            const ridgeResponse: Nullable<NatGetRidge> = await this.props.asyncCallFunction(
                this.props.ridgeRepo.getRidgeList.bind(this.props.ridgeRepo, this.props.selectedCondominiumCd),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (ridgeResponse && ridgeResponse.details) {
                this.setState({ridge: ridgeResponse.details})
            }
        }

    }

    onChangeRidgeCd(event: SelectChangeEvent<unknown>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.ridgeCd = String(event.target.value)
        this.setState({searchCondition: seachConditions})
    }

    onChangeRoomNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.roomNumber = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.familyName = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.firstName = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.familyNameKana = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.firstNameKana = event.target.value
        this.setState({searchCondition: seachConditions})
    }


    renderResidentUserTable(residentusers: ResidentUserInfo[]): Nullable<ReactElement> {
        if (residentusers.length === 0) {
            return null
        }


        return (
            <ConditionTableFixed stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell key={'roomNumber'} align={'center'}>部屋番号</TableCell>
                        <TableCell key={'residentUserName'} align={'center'}>氏名</TableCell>
                        <TableCell key={'adminUserName'} align={'center'}>管理者確認用氏名</TableCell>
                        <TableCell key={'role'} align={'center'}>権限</TableCell>
                        <TableCell key={'mailAddress'} align={'center'}>メールアドレス</TableCell>
                        <TableCell key={'updateDatetime'} align={'center'}>更新日時</TableCell>
                        <TableCell key={'operation'} align={'center'}>操作</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.searchResult.limitOverFlag !== 1 && this.state.residentUsers.length > 0 &&
                        this.state.residentUsers.map(
                            residentUser => this.renderResidentUserRecord(residentUser),
                        )
                    }
                </TableBody>
            </ConditionTableFixed>
        )
    }


    updateSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): void {
        if (this.props.setSelectedResidentUserInfo) {
            this.props.setSelectedResidentUserInfo(selectedResidentUserInfo)
        }

    }

    updateSelectedExclusionResidentUserInfo(): void {
        if (this.props.setSelectedExclusionResidentUserInfo) {
            this.props.setSelectedExclusionResidentUserInfo(this.state.selectedUserList)
        }
    }

    onClickOperationButton(residentUser: ResidentUserInfo): void {

        if (this.judgSelectedExcludeResidentUser(residentUser) === true) {
            // 既に選択済みの場合
            const selectedUserList: SelectedUserList[] = this.state.selectedUserList
            this.state.selectedUserList.map((selectedUser, index) => {
                if (selectedUser.ridgeCd === residentUser.ridgeCd &&
                    selectedUser.roomNumber === residentUser.roomNumber) {
                    selectedUserList.splice(index, 1)
                }
            })
            if (this.props.maxSelectableKeyNumber &&
                selectedUserList.length > this.props.maxSelectableKeyNumber) {
                this.setState({selectedExcludeDisabled: true})
            } else {
                this.setState({selectedExcludeDisabled: false})
            }
            this.setState({selectedUserList: selectedUserList})
        } else {
            // 未選択の場合
            const selectedUserList: SelectedUserList[] = this.state.selectedUserList
            selectedUserList.push({
                ridgeCd: residentUser.ridgeCd,
                ridgeName: residentUser.ridgeName,
                roomNumber: residentUser.roomNumber,
            })
            this.setState({selectedUserList: selectedUserList})

            if (this.props.maxSelectableKeyNumber &&
                selectedUserList.length > this.props.maxSelectableKeyNumber) {
                this.setState({selectedExcludeDisabled: true})
            } else {
                this.setState({selectedExcludeDisabled: false})
            }
        }
    }

    judgSelectedExcludeResidentUser(residentUser: ResidentUserInfo): boolean {
        const selectedUserList: SelectedUserList | undefined =
            this.state.selectedUserList.find(
                selectedUser =>
                    selectedUser.ridgeCd === residentUser.ridgeCd &&
                    selectedUser.roomNumber === residentUser.roomNumber
            )
        if (selectedUserList === undefined) {
            return false
        } else {
            return true
        }
    }

    renderResidentUserRecord(residentUser: ResidentUserInfo): ReactNode {
        const displayUserNameForManagement = getDisplayUserNameForManagement(residentUser)

        return (
            <SelectedResidentUserTable
                key={residentUser.roomNumber + '_' + residentUser.condominiumCd +
                    '_' + residentUser.ridgeCd + '_' + residentUser.seq}
                selectedflg={this.judgSelectedExcludeResidentUser(residentUser) ? 'true' : 'false'}
            >
                <TableCellWordBreakAll align={'center'}>
                    {residentUser.ridgeName} {residentUser.roomNumber}
                </TableCellWordBreakAll>
                <TableCell align={'center'}>{residentUser.familyName} {residentUser.firstName}</TableCell>
                <TableCell align={'center'}>{displayUserNameForManagement}</TableCell>
                <TableCell align={'center'}>{residentUser.roleName}</TableCell>
                <TableCellWordBreakAll align={'center'}>
                    {residentUser.mailAddressPc}
                    {(residentUser.mailAddressPc) ? <br/> : <></>}
                    {residentUser.mailAddressMb}
                </TableCellWordBreakAll>
                <TableCell align={'center'}>{formatDateTimeForUpdateDate(residentUser.updateDatetime)}</TableCell>
                {this.props.selectUserType === SELECT_USER_TYPE.ROOM_NUMBER.value &&
                    <TableCell align={'center'}>
                        <AdminPrimaryButton onClick={() => this.onClickOperationButton(residentUser)}>
                            {this.judgSelectedExcludeResidentUser(residentUser) === true ? '解除' : '追加'}
                        </AdminPrimaryButton>
                    </TableCell>
                }
                {this.props.selectUserType === SELECT_USER_TYPE.USER.value &&
                    <TableCell align={'center'}>
                        <AdminPrimaryButton onClick={() => this.updateSelectedResidentUserInfo(residentUser)}>
                            選択
                        </AdminPrimaryButton>
                    </TableCell>
                }
            </SelectedResidentUserTable>
        )
    }


    async onClickSearchButton(): Promise<void> {
        await this.searchResidentUsers(
            this.state.searchCondition,
            this.state.searchConditionSortInfo,
        )
    }

    // 居住者ユーザ検索
    async searchResidentUsers(
        searchCondition?: GetRoomToResidentParams,
        searchConditionSortInfo?: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {

            let getRoomToResidentParams: GetRoomToResidentParams = {}
            if (searchCondition) {
                getRoomToResidentParams = {
                    ...searchCondition,
                }
            }
            if (this.props.selectedCondominiumCd) {
                getRoomToResidentParams.condominiumCd = this.props.selectedCondominiumCd
            }
            if (this.props.mainUserFlag) {
                getRoomToResidentParams.mainUserFlag = 1
            }
            if (this.props.cardKeyNumberIsNotNullFlg) {
                getRoomToResidentParams.cardKeyNumberIsNotNullFlg = 1
            }

            if (this.props.allResidentStatus) {
                getRoomToResidentParams.status = `${RESIDENT_STATUS.UNREGISTERED.value},${RESIDENT_STATUS.BEFORE_OCCUPANCY.value},${RESIDENT_STATUS.REGISTERED.value},${RESIDENT_STATUS.ABOLITION.value}`
            } else {
                if (this.props.invalidUserSelectFlag) {
                    getRoomToResidentParams.status = `${RESIDENT_STATUS.UNREGISTERED.value},${RESIDENT_STATUS.BEFORE_OCCUPANCY.value},${RESIDENT_STATUS.REGISTERED.value}`
                } else if (this.props.unregisteredResidentStatus) {
                    getRoomToResidentParams.status = `${RESIDENT_STATUS.UNREGISTERED.value}`
                } else {
                    getRoomToResidentParams.status = `${RESIDENT_STATUS.REGISTERED.value}`
                }
            }

            if (this.props.excudeResidentUserInfo) {
                getRoomToResidentParams.excludeResidentUserInfo = [
                    `excludeCondominiumCd:${this.props.excudeResidentUserInfo.excludeCondominiumCd}`,
                    `excludeRidgeCd:${this.props.excudeResidentUserInfo.excludeRidgeCd}`,
                    `excludeRoomNumber:${this.props.excudeResidentUserInfo.excludeRoomNumber}`,
                ]
            }
            if (searchConditionSortInfo) {
                const sortInfos: string[] = []
                searchConditionSortInfo.forEach((sortInfo) => {
                    sortInfos.push(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
                })
                getRoomToResidentParams.sortInfo = sortInfos
            }


            // 部屋居住者一覧取得
            const getResidentUserResponse: Nullable<NatGetRoomToResident> =
                await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.getRoomToResident.bind(
                        this.props.roomToResidentRepo,
                        getRoomToResidentParams,
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getResidentUserResponse && getResidentUserResponse.details) {
                let residentUserInfo: ResidentUserInfo[] = []
                let searchResult: SearchResult = {limitOverFlag: 0, total: 0}
                if (this.props.sameRoomDuplicateExclusionFlag) {
                    residentUserInfo = this.sameRoomDuplicateExclusion(getResidentUserResponse.details.residentUserInfo)
                    searchResult = {
                        limitOverFlag: getResidentUserResponse.details.searchResult.limitOverFlag,
                        total: residentUserInfo.length,
                    }
                } else {
                    residentUserInfo = getResidentUserResponse.details.residentUserInfo ?
                        getResidentUserResponse.details.residentUserInfo : []
                    searchResult = getResidentUserResponse.details.searchResult
                }
                this.setState({
                    residentUsers: residentUserInfo,
                    searchResult: searchResult,
                })
            }
        } finally {
            this.setState({clickSearchButton: true})
            this.props.eventEmitter.closeLoading()
        }
    }

    sameRoomDuplicateExclusion(residentUserInfo: ResidentUserInfo[]): ResidentUserInfo[] {
        return residentUserInfo.reduce((result: ResidentUserInfo[], current) => {
            const sameRoomIndex: number = result.findIndex(value =>
                value.ridgeCd === current.ridgeCd &&
                value.roomNumber === current.roomNumber &&
                value.seq < current.seq,
            )

            if (sameRoomIndex !== -1) {
                result.splice(sameRoomIndex, 1)
            }
            result.push(current)
            return result
        }, [])
    }

    getRidgeList(): OptionProps[] {
        let ridges: OptionProps[] = []
        if (this.state.ridge) {
            ridges = this.state.ridge.map((ridge) => {
                return ({
                    label: `${ridge.ridgeCd}：${ridge.ridgeName}`,
                    value: `${ridge.ridgeCd}`,
                })
            })
        }

        return [{
            label: '棟を指定してください',
            value: '',
        }, ...ridges]
    }

    render(): ReactNode {
        return <>
            <Dialog
                scroll={'paper'}
                id={'pp-dialog'}
                open={true}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                maxWidth={'xl'}
            >
                <StyledDialogFixed>
                    <AdminPageHeadingArea
                        title={this.props.selectUserType === SELECT_USER_TYPE.USER.value ? 'ユーザ選択' : '同時入室番号選択'}
                    />
                </StyledDialogFixed>
                <StyledDialogContent>
                    <ListSearchFormArea
                        onEnterKey={this.onClickSearchButton}
                    >
                        <StyledDialogActions>
                            <ConditionTableFixed>
                                <colgroup>
                                    <col width={'10%'}/>
                                    <col width={'8%'}/>
                                    <col width={'25%'}/>
                                    <col width={'8%'}/>
                                    <col width={'25%'}/>
                                </colgroup>
                                <ConditionTableBody>
                                    <ConditionTableRow>
                                        <ConditionCategoryCell>物件情報</ConditionCategoryCell>
                                        <ConditionInputCellForColgroup>棟名</ConditionInputCellForColgroup>
                                        <ConditionInputCellForColgroup>
                                            <PPSelect
                                                autoFocus
                                                data={this.getRidgeList()}
                                                onChange={this.onChangeRidgeCd}
                                                value={this.state.searchCondition.ridgeCd}
                                                eventKeys={['ridgeCd']}
                                            />
                                        </ConditionInputCellForColgroup>
                                        <ConditionInputCellForColgroup>部屋番号</ConditionInputCellForColgroup>
                                        <ConditionInputCellForColgroup>
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 4,
                                                    },
                                                }}
                                                fullWidth
                                                onChange={this.onChangeRoomNumber}
                                            />
                                        </ConditionInputCellForColgroup>
                                        <ConditionButtonCell/>
                                    </ConditionTableRow>
                                    <ConditionTableRow>
                                        <ConditionCategoryCell rowSpan={2}>居住者情報</ConditionCategoryCell>
                                        <ConditionColumNameCell>氏名(姓)</ConditionColumNameCell>
                                        <ConditionInputCellForColgroup>
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 10,
                                                    },
                                                }}
                                                fullWidth
                                                onChange={this.onChangeFamilyName}
                                            />
                                        </ConditionInputCellForColgroup>
                                        <ConditionColumNameCell>氏名(名)</ConditionColumNameCell>
                                        <ConditionInputCellForColgroup>
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 10,
                                                    },
                                                }}
                                                fullWidth
                                                onChange={this.onChangeFirstName}
                                            />
                                        </ConditionInputCellForColgroup>
                                        <ConditionButtonCell/>
                                    </ConditionTableRow>
                                    <ConditionTableRow>
                                        <ConditionColumNameCell>氏名(セイ)</ConditionColumNameCell>
                                        <ConditionInputCellForColgroup>
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 20,
                                                    },
                                                }}
                                                fullWidth
                                                onChange={this.onChangeFamilyNameKana}
                                            />
                                        </ConditionInputCellForColgroup>
                                        <ConditionColumNameCell>氏名(メイ)</ConditionColumNameCell>
                                        <ConditionInputCellForColgroup>
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 20,
                                                    },
                                                }}
                                                fullWidth
                                                onChange={this.onChangeFirstNameKana}
                                            />
                                        </ConditionInputCellForColgroup>
                                        <ConditionButtonCell>
                                            <AdminDefaultMediumButton
                                                onClick={this.onClickSearchButton}>
                                                居住者ユーザを検索する
                                            </AdminDefaultMediumButton>
                                        </ConditionButtonCell>
                                    </ConditionTableRow>
                                </ConditionTableBody>
                            </ConditionTableFixed>
                        </StyledDialogActions>
                    </ListSearchFormArea>
                    <SearchResultTotal>
                        {this.state.clickSearchButton === true &&
                            <Box mt={'5px'} ml={'10px'}>
                                <Typography variant={'body2'}>
                                    {this.state.searchResult.limitOverFlag === 1 &&
                                        Messages.IOPCC0016
                                            .toString(HKConstants.VMN.RES.RESIDENCE_USER_SEARCH_RESULTS_LIMIT)
                                    }
                                    {this.state.searchResult.limitOverFlag !== 1 &&
                                        this.state.residentUsers.length > 0 &&
                                        this.state.searchResult.total + '件'
                                    }
                                    {this.state.searchResult.limitOverFlag !== 1 &&
                                        this.state.residentUsers.length === 0 &&
                                        '0件 ' + Messages.IOPCC0014.toString('')
                                    }
                                </Typography>
                            </Box>
                        }
                    </SearchResultTotal>
                    <PageMainArea>
                        {this.state.searchResult.limitOverFlag !== 1 && this.state.residentUsers.length > 0 &&
                            this.renderResidentUserTable(this.state.residentUsers)
                        }
                    </PageMainArea>
                </StyledDialogContent>
                <StyledDialogActions>
                    <PageFooterArea>
                        {this.props.selectUserType === SELECT_USER_TYPE.ROOM_NUMBER.value &&
                            <PageFotterAreaRight>
                                <AdminPrimaryButton
                                    disabled={this.state.residentUsers.length === 0 ||
                                        this.state.selectedUserList.length === 0 ||
                                        this.state.selectedExcludeDisabled === true}
                                    onClick={this.updateSelectedExclusionResidentUserInfo}
                                >
                                    確定
                                </AdminPrimaryButton>
                            </PageFotterAreaRight>
                        }
                        <PageFotterAreaLeft>
                            <BackLink
                                onClick={this.props.closeSelectResidentUserDiaLog}
                            >
                                キャンセル
                            </BackLink>
                        </PageFotterAreaLeft>
                    </PageFooterArea>
                </StyledDialogActions>
            </Dialog>
        </>
    }
}

interface SelectedResidentUser {
    selectedflg: 'true' | 'false'
}

export const SelectedResidentUserTable = styled(TableRow)<SelectedResidentUser>`


  ${props => props.selectedflg === 'true' ? ` &.MuiTableRow-root {
      background-color: #ffd966;
   }` : ``}

  ${props => props.selectedflg === 'true' ? ` &.MuiTableRow-root button {
      background-color: #afabab;
   }` : ``}

`

const StyledDialogFixed = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    padding: 24px 24px 0;
    min-width: 960px;
  }
`

const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 0 24px 8px;
    min-width: 960px;
  }
`

const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 8px 24px 24px;
  }
`

const SearchResultTotal = styled.div`
  padding: 8px 12px;
`

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
